import {PlatformPropertyCardProperty} from '@flexinet/ui-components';
import {useAllowedActions} from './useAllowedActions.ts';
import {RbacAction} from '../config/rbac/actions.ts';

// FNP-1935: rbac is an RbacAction, so a misspelt action on a profile property
// fails to compile instead of silently hiding the property.
export type RbacGatedItem = { rbac?: RbacAction };

export type RbacGatedProperty = PlatformPropertyCardProperty & RbacGatedItem;

export const useAllowedItems = () => {

    const {allowedActions} = useAllowedActions()

    const filterAllowed = <T extends RbacGatedItem>(items: T[]): T[] => {

        return items.filter(item => {

            // if no rbac is specified allow it
            if (typeof item.rbac === 'undefined') {
                return true;
            }
            // if rbac property is specified - evaluate it and return accordingly
            return allowedActions.includes(item.rbac);
        });

    };

    return {
        filterAllowed,
    };

};
